import React, { useState, useEffect, useRef } from "react"
import { render } from "react-dom"
import "./frontend.css"

const longListDivsToUpdate = document.querySelectorAll(".long-list-block-update-me")

longListDivsToUpdate.forEach( div => {
    const data = JSON.parse(div.querySelector("pre").innerHTML)    

    render(<LongListBlock {...data}/>, div)
    div.classList.remove(".long-list-block-update-me")
})

function LongListBlock(props){
    const {heading, introParagraph, theList, imageUrl} = props
    const sectionHeadingRef = useRef(null)

    useEffect( () => {
        sectionHeadingRef.current.innerHTML = heading
    }, [])

    return(
        <>
            <div className="container">
                <div className="long-list-intro">
                    <h2 ref={sectionHeadingRef}>OUR RICH DIVERSITY</h2>
                    <p>{introParagraph}</p>
                </div>
                <div className="long-list-body">
                    <ul class="long-list-content">
                        {
                            theList.map( (listItem, index) => {
                                return (
                                    <>
                                    <li key={index}>
                                        <h3><div class="bullet"></div><span>{listItem.listHeading}</span></h3>
                                        <p>{listItem.explanation}</p>
                                    </li>
                                    </>
                                )
                            })
                        }
                    </ul>
                    <div class="long-list-image">
                        <img src={imageUrl} alt="" />
                    </div>
                </div>
            </div>
        </>
    )    
}